/**
 * @preserve C.A.S./Track - Shared upload routines used by Track.  Relies on
 * dropzone being present.  This code is used in both master and the
 * web_rewrite branch so we use $j to represent the jQuery object here.
 *
 * Copyright (C) 2017 Software Consulting Services, LLC.
 */
( function() {
  Dropzone.autoDiscover = false;
})();

function SCSUploader( elem, options ) {
  var $j = jQuery;
  // Use our own alias for jQuery since this code is shared.
    
  var fileTypeList = [
    { "value": 0, "text": "File Type" }
  ];
  if (options.jsonConfigVals && options.jsonConfigVals.AdSubmit != undefined) {
     for (var key in options.jsonConfigVals.AdSubmit) {
         if (options.jsonConfigVals.AdSubmit[key] && options.jsonConfigVals.AdSubmit[key].active) {
            fileTypeList = fileTypeList.concat(
              { "value": options.jsonConfigVals.AdSubmit[key].id,
                "text": options.jsonConfigVals.AdSubmit[key].description } )
         }
     }
  }

  /* Generic utility functions */

  function getTrackSpicePlDir() {
    if ( typeof menuManager == "object" ) {
      return menuManager.getLocCGI_AI();
    }
    else if ( typeof APP_URLs == "object" ) {
      return APP_URLs["T"].substring( 0, APP_URLs["T"].lastIndexOf( "/" ) );
    }
    else {
      throw( "Error could not determine the URL to use" );
    }
  }

  function canMakePreviewForFile( file ) {
    var fileType = file.type;
    var fileExt = file.name.substring( file.name.lastIndexOf( "." ) + 1 );
    if ( fileType.match( /image.*/ ) ||
         fileType == "application/pdf" ||
         fileType == "application/postscript" ) {
      return true;
    }
    else {
      if ( fileExt == "pdf" || fileExt == "ps" || fileExt == "eps" ||
           fileExt == "ept" || fileExt == "tiff" ) {
        return true;
      }
      else {
        return false;
      }
    }
  };

  function getPreviewURL( file ) {
    if ( canMakePreviewForFile( file ) ) {
      var filename = encodeURIComponent( file.name );
      return constructURL( "getuplfilepreview",
                           { "fileId": file.scsId }, getTrackSpicePlDir(),
                           filename );
    }
    else {
      return "";
    }
  };

  function postTrackJSON( command, callback, params ) {
    return postJSON( command, callback, params, null,
                     getTrackSpicePlDir() + "/spice.pl" );
  };

  function getFontAwesomePreview( file ) {
    var idx = file.name.lastIndexOf( "." )
    var fileExt = file.name.substring( idx + 1 );
    var faClass = "fa-file-o";

    if ( file.type.match( /text.*/ ) ) {
      faClass =  "fa-file-text-o";
    }
    else if ( file.type.match( /application.*zip/ ) ) {
      faClass = "fa-file-archive-o";
    }
    else if ( file.type.match( /word/ ) ) {
      faClass = "fa-file-word-o";
    }
    else {
      faClass = "fa-file-o";
    }

    // Add the file extension into the generic file preview if the file has one
    if ( ( faClass == "fa-file-o" ) && ( idx != -1 ) ) {
      return  $j( '<span class="fa-stack">' ).
        append( $j( '<span class="fa-stack-1x dz-file-type">' ).text( fileExt ),
                $j( '<i class="fa ' + faClass + ' fa-stack-2x">' ) );
    }
    else {
      return $j( '<i class="fa fa-stack-2x ' + faClass + '"></i>' );
    }
  };

  function getFileTypeId( file ) {
    return "file_" + file.scsId + "_type";
  }

  /**
   * Get a note from user input.
   * @param file
   * @param existingNotes
   */
  this.getNoteFromFloatingDiv = function( file, existingNotes ) {
    $j( "#notes_area" ).val( existingNotes );

    var fDiv = new FloatingDiv( $j( "#notes_div" )[0], {
      "title": "Notes",
      "cancelStandard": true,
      "saveFunc": function() {
        var newNotes = $j( "#notes_area" ).val();
        self.saveNote( file, newNotes );
      }
    } );
    showElement( $j( "#notes_div" )[0] );
    fDiv.show();
    $j( "#notes_area" ).focus();
  };

  this.getNoteFromModal = function( file, existingNotes ) {
    var $notesArea = $j( '<textarea class="form-control" rows="5" cols="40"/>' ).val( existingNotes );
    modalM( "Note", $notesArea, "Save", "Cancel",
            function( btn ) {
              if ( btn != "Save" ) {
                return;
              }
              self.saveNote( file, $notesArea.val() );
            } );
  };

  this.getNote = function( file ) {
    var existingNotes = self.notes[file.scsId] || "";
    if ( typeof FloatingDiv == "function" ) {
      self.getNoteFromFloatingDiv( file, existingNotes );
    }
    else {
      self.getNoteFromModal( file, existingNotes );
    }
  };

  this.removeAllFiles = function() {
    self.removingAll = true;
    self.dropzone.removeAllFiles( true );
    self.removingAll = false;
    if ( self.confirmNum != "" ) {
      postTrackJSON( "delete_upload", null, { "confirm_num": self.confirmNum } );
    }
  };

  this.saveNote = function( file, notes ) {
    var params =  {
      "fileId": file.scsId,
      "notes": notes
    };

    postTrackJSON( "upload_files_note_save", function() {
      self.notes[file.scsId] = notes;
    }, params );
  };

  this.addButtons = function( file ) {
    var $removeBtn = $j( '<button type="button" class="btn btn-default btn-xs"><i class="fa fa-trash-o fa-lg fa-fw" aria-label="Remove"></i></button>' );
    var $notesBtn = $j( '<button type="button" class="btn btn-default btn-xs"><i class="fa fa-comment-o fa-lg fa-fw" aria-label="Add Notes"></i></button>' );

    $j( file.previewTemplate )
      .find( ".dz-details" )
      .append( $removeBtn, $notesBtn );
    var fileTypeId = getFileTypeId( file );
    var $fileTypeSelect = $j( '<select>' );
    $fileTypeSelect.attr( "name", fileTypeId );
    $fileTypeSelect.attr( "id", fileTypeId );
    populateSelectList( $fileTypeSelect[0], fileTypeList, false );

    file.$actionsDiv.empty();
    file.$actionsDiv.append( $fileTypeSelect );

    var defaultFileType = 0;
    if ( self.options.defaultFileType ) {
      defaultFileType = self.options.defaultFileType;
    }

    var fileType = ( file.fileType && file.fileType >= 1 &&
                     file.fileType <= 4  ) ? file.fileType : defaultFileType;
    $fileTypeSelect.val( fileType );
    $fileTypeSelect[0].options[0].disabled = true;

    $removeBtn.click( function( e ) {
      self.dropzone.removeFile( file );
    } );
    $notesBtn.click( function( e ) {
      self.getNote( file );
    } );
    $fileTypeSelect.change( function() {
      postTrackJSON( "upload_files_set_file_type", null,
                { "fileid": file.scsId,
                  "fileType": $j( this ).val() } );
    } );
    $fileTypeSelect.change();
  };

  /* Dropzone event callbacks */
  this.addedFile = function( file ) {
    file.$actionsDiv = $j( '<div class="dz-actions"></div>' );
    var $removeElement = $j( '<button type="button" class="btn btn-default"><i class="fa fa-remove fa-lg fa-fw"></i>Cancel</button>' );
    $removeElement.click( function( e ) {
      self.dropzone.removeFile( file );
    } );
    file.$actionsDiv.append( $removeElement );
    $j( file.previewTemplate ).append( file.$actionsDiv );
  };

  this.removedFile = function( file ) {
    if ( !self.removingAll ) {
      // Only send the remove command if we are not removing all and if
      // we have an scsId (file id) for this file.
      if ( file.scsId ) {
        postTrackJSON( "upload_files_delete", null,
                  { "confirm_num": self.confirmNum,
                    "fileId": file.scsId } );
      }
    }
    self.notes[file.scsId] = "";
  };

  this.processing = function( file ) {
    // Disable the buttons button during uploads
    if ( self.options.actionButton ) {
      $j( self.options.actionButton ).prop( "disabled", true );
    }
    if ( self.options.removeAll ) {
      self.$removeAllBtn.prop( "disabled", true );
    }
  };

  this.successMultiple = function( files, obj, e ) {
    if ( !obj ) {
      return;
    }

    var webResp = obj["WebResponse"];

    $j.each( files, function( i, file ) {
      var fileList = $j.grep( webResp.uploadedFileList, function( f ) {
        return f.paramName == self.paramName + "[" + i + "]";
      } );
      if ( fileList.length == 1 ) {
        // File was copied to the confirmation folder
        file.scsId = fileList[0].fileId;
        file.scsName = fileList[0].filename;
        $j( file.previewTemplate ).find( "span[data-dz-name]" ).text( file.scsName );
        if ( !file.type.match( /image.*/ ) ||
             file.type == "image/x-eps" ||
             file.type == "image/tiff" ) {
          var url = getPreviewURL( file );
          self.previewQueue.push( { "file": file, "url": url } );
        }
        self.addButtons( file );
      }
      else if ( fileList.length > 1 ) {
        // Must have been an archive that got exapnded.
        // Remove it from the Dropzone area since we are not saving it and
        // add all the files it created.
        self.dropzone.removeFile( file );
        self.addFiles( fileList );
      }
    } );
  };

  this.queueComplete = function() {
    var p = self.previewQueue.shift();
    while ( !isUndefinedOrNull( p ) ) {
      // Updated previews that need to come from the backend.  For
      // whatever reason, the uploads get messed up if we try to
      // do this during processing.
      if ( p.url != "" ) {
        self.dropzone.emit( "thumbnail", p.file, p.url );
        p.file.previewElement.classList.remove( "dz-file-preview" );
      }
      else {
        var $imgDiv = $j( p.file.previewElement ).find( ".dz-image" );
        $imgDiv.empty();
        var $prev = getFontAwesomePreview( p.file );
        $imgDiv.append( $prev );
      }
      p = self.previewQueue.shift();
    }
    // Enable the buttons
    if ( self.options.actionButton ) {
      $j( self.options.actionButton ).prop( "disabled", false );
    }
    if ( self.options.removeAll ) {
      self.$removeAllBtn.prop( "disabled", false );
    }
  };

  this.addFile = function( i, file ) {
    var newFile = { "name": file.filename,
                    "size": file.fileSize,
                    "type": file.mimeType,
                    "scsId": file.fileId,
                    "fileType": file.fileType };
    self.dropzone.files.push( newFile );
    self.dropzone.emit( "addedfile", newFile );
    self.previewQueue.push( { "file": newFile,
                              "url": getPreviewURL( newFile ) } );
    self.addButtons( newFile );
    self.dropzone.emit( "complete", newFile );
  },

  this.addFiles = function( fileList ) {
    $j.each( fileList, self.addFile );
  },

  this.uploadBase64Image = function( base64Image, confirmNum, fileName ) {
    const imageData = base64Image.split(",")[1];
    const mimeString = base64Image.split(",")[0].split(":")[1].split(";")[0];
    const byteString = atob(imageData);

    // Convert base64 to ArrayBuffer
    const ab = new ArrayBuffer(byteString.length);
    const ia = new Uint8Array(ab);
    for (let i = 0; i < byteString.length; i++) {
      ia[i] = byteString.charCodeAt(i);
    }

    // Create a Blob and File object
    const blob = new Blob([ab], { type: mimeString });
    const file = new File([blob], fileName, { type: mimeString });
    const formData = new FormData();
    formData.append( "form_id", "ad_files" );
    formData.append( "confirm_num", confirmNum );
    formData.append( "upload_file[0]", file );
    formData.append( "method", "POST" );
    Command( formData, function( reply ) {
      if ( reply.error ) {
        alertM( reply.TranslatedMessage || reply.error );
        return;
      }
      else {
        file.scsId = reply.uploadedFileList[ 0 ].fileId;
        self.dropzone.files.push( file );
        self.dropzone.emit( "addedfile", file );
        self.previewQueue.push( {
          file,
          url: URL.createObjectURL( file ),
        } );
        self.addButtons( file );
        self.dropzone.emit( "complete", file );
      }
    } );
  },

  this.validateFileTypes = function() {
    if ( !self.usingPreflights ) {
      return true;
    }

    var status = true;
    $j.each( self.dropzone.files,
             function( i, file ) {
               var val = $fileType = $j( "#" + getFileTypeId( file ) ).val();
               if ( !val || val <= 0 || val > 4 ) {
                 status = false;
               }
             } );

    if ( !status ) {
      alertM( self.fileTypeErrorMessage, "Error" );
    }

    return status;
  };

  /*
   * Return an array of files.  That can be used to repopulate a Dropzone area
   * with a call to the function addFiles later on.
   */
  this.getFiles = function() {
    var files = [];
    $j.each( self.dropzone.files,
             function( i, f ) {
               files.push( { "filename": f.scsName ? f.scsName : f.name,
                             "fileSize": f.size,
                             "mimeType": f.type,
                             "fileId": f.scsId,
                             "fileType": f.fileType } );
             } );

    return files;
  };

  this.createDropzone = function( elem, userOptions ) {
    var options = { "removeAll": true,
                    "actionButton": null,
                    "newConfirmNumberCallback": $j.noop },
        $fileUploadArea = $j( elem ),
        url = getTrackSpicePlDir() + "/spice.pl",
        actualCreate = function() {
          var params = parseQueryString( self.extraParams );
          params["form_id"] = self.formId;
          params["confirm_num"] = self.confirmNum;

          self.dropzone = new Dropzone( elem, {
            "dictDefaultMessage": "Drop files here or click to upload",
            "paramName": self.paramName,
            "url": url,
            "params": params,
            "uploadMultiple": true,
            "parallelUploads": 10,
            "maxFilesize": 8192,
            "maxFiles": userOptions.maxFiles || null,
            "timeout": null,
            "init": function() {
              if ( self.options.removeAll ) {
                self.$removeAllBtn = $j( '<button type="button" class="btn btn-default"><i class="fa fa-trash-o fa-2x" aria-label="Remove All Files"></i></button>' );

                $j( elem ).prepend( $j( '<div class="dz-remove-all" style="margin-top: 0.5em">' ).append( self.$removeAllBtn ) );
                self.$removeAllBtn.click( self.removeAllFiles );
              }

              this.on( "addedfile", self.addedFile );
              this.on( "removedfile", self.removedFile );
              this.on( "processing", self.processing );
              this.on( "successmultiple", self.successMultiple );
              this.on( "queuecomplete", self.queueComplete );
            }
          } );
        };

    $j.extend( options, userOptions );

    self.options = options;
    self.formId = $fileUploadArea.attr( "data-form-id" );
    self.paramName = $fileUploadArea.attr( "data-param-name" );
    self.confirmNum = $fileUploadArea.attr( "data-confirm-num" );
    self.usingPreflights = $fileUploadArea.attr( "data-using-preflights" ) == "true";
    self.extraParams = $fileUploadArea.attr( "data-extra-params" ) || "";
    self.fileTypeErrorMessage = $fileUploadArea.attr( "data-file-type-error-message" );

    if ( !self.confirmNum ) {
      postTrackJSON( "upload_files_new_confirm_number",
                     function( obj ) {
                       self.confirmNum = obj["confirmnum"];
                       actualCreate();
                       options.newConfirmNumberCallback( self.confirmNum );
                     } );
    }
    else {
      actualCreate();
    }
  };

  /* Initialization */
  var self = this;
  this.previewQueue = [];
  this.removingAll = false;
  this.notes =  {};
  this.createDropzone( elem, options );
};
